'use client';

import useGlobalState from '@hooks/useGlobalState';
import useMyHeartItem from '@hooks/useMyHeartItem';
import type { Product } from '@wconcept/wconcept-common/models/renewal/product';
import { useCallback } from 'react';

interface UseCornerAreaHeartParams {
  doAfterAddMyHeart?: (product: Product, index?: number) => void;
  doAfterDeleteMyHeart?: (product: Product, index?: number) => void;
}

export const useCornerAreaHeart = (params?: UseCornerAreaHeartParams) => {
  const {
    assistData,
    myHeartList,
    addMyHeartProductItem,
    deleteMyHeartProdcutItem,
  } = useGlobalState();

  const { onClickHeart: onClickMyHeart } = useMyHeartItem({
    isLogin: !!assistData?.isLogin,
    doAfterAddMyHeart: (param, product, index) => {
      params?.doAfterAddMyHeart?.(product as Product, index);
      addMyHeartProductItem(param.itemCd);
    },
    doAfterDeleteMyHeart: (param, product, index) => {
      params?.doAfterDeleteMyHeart?.(product as Product, index);
      deleteMyHeartProdcutItem(param.itemCd);
    },
  });

  const isHearted = useCallback(
    (itemCd?: string): boolean =>
      itemCd ? !!myHeartList?.product?.has(itemCd) : false,
    [myHeartList?.product]
  );

  const onClickHeart = useCallback(
    async (product: Product, active: boolean, index?: number) =>
      onClickMyHeart?.(product, active, index),
    [onClickMyHeart]
  );

  return { isHearted, onClickHeart };
};
